import { FC, ReactNode } from 'react'
import { Download, DownloadType } from './Download'
import { Form, FormType } from './form/Form'
import { SendEmail, SendEmailType } from './SendEmail'

export const CampaignEmployee: FC &
  DownloadType &
  FormType &
  SendEmailType = (): ReactNode => <></>

CampaignEmployee.Download = Download
CampaignEmployee.Form = Form
CampaignEmployee.SendEmail = SendEmail
